import { Formik } from 'formik'
import { ReactElement, useCallback } from 'react'
import { useSetRecoilState } from 'recoil'
import axios from 'axios'
import { getServerHost } from '../utils/get-server-host'
import { Flexbox } from '../components/flexbox/flexbox'
import { loggedUserState } from '../states/logged-user-state'

interface FormErrors {
  email?: string
}

const LoginForm = (): ReactElement => {
  const setUser = useSetRecoilState(loggedUserState)

  const onSubmit = useCallback(async (values, { setSubmitting }) => {
    const { email, password } = values
    const { data } = await axios.post(getServerHost('login'), {
      email,
      password,
    })

    if (data.token) {
      window.localStorage.setItem('token', data.token)
    }

    if (data.user) {
      // Log user
      setUser(data.user)
    }
  }, [])

  return (
    <Formik
      initialValues={{ email: '', password: '' }}
      validate={(values) => {
        const errors: FormErrors = {}
        if (!values.email) {
          errors.email = 'Required'
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
          errors.email = 'Invalid email address'
        }
        return errors
      }}
      onSubmit={onSubmit}>
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
        <form onSubmit={handleSubmit}>
          {/* @ts-ignore */}
          <Flexbox isCol alignItems="center">
            <div className="form-control w-full max-w-xs">
              <input
                type="email"
                name="email"
                onChange={handleChange}
                onBlur={handleBlur}
                placeholder="email"
                value={values.email}
                className="input input-bordered w-full max-w-xs text-center"
              />
              <label className="label">
                <span className="label-text-alt text-error">
                  {errors.email && touched.email && errors.email.toString()}
                </span>
              </label>
            </div>

            <input
              type="password"
              name="password"
              onChange={handleChange}
              placeholder="password"
              onBlur={handleBlur}
              value={values.password}
              className="input input-bordered w-full min-w-8 mb-4 text-center"
            />
            <label className="label">
              <span className="label-text-alt text-error">
                {errors.password && touched.password && errors.password.toString()}
              </span>
            </label>

            <button type="submit" className="btn w-full" disabled={isSubmitting}>
              Submit
            </button>
          </Flexbox>
        </form>
      )}
    </Formik>
  )
}

export default LoginForm